import _toConsumableArray from "E:\\RiderProjects\\pdcweb\\node_modules\\@babel\\runtime-corejs2/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\RiderProjects\\pdcweb\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { SortField, toTree } from "../../utils/helper";
import { formatTime, treeToList, listToTree, getTreeParents, getTreeParentsWithSelf } from "../../utils";
export default {
  name: 'rolePermission',
  data: function data() {
    return {
      headTitle: '',
      isadd: false,
      editVisible: false,
      roleId: 0,
      pageCount: 1,
      multipleSelection: [],
      delList: [],
      expandRowKeys: [],
      loading: false,
      query: {
        Field1: '',
        Field2: '',
        Field3: ''
      },
      loadingPermissions: false,
      roles: [],
      permissionTree: [],
      checkedPermissions: [],
      loadingRoles: false
    };
  },
  created: function created() {
    this.getPermissions();
    this.getRoles();
  },
  computed: {
    disabledSave: function disabledSave() {
      return !(this.roleId > 0 && this.checkedPermissions.length > 0);
    }
  },
  methods: {
    roleSelect: function roleSelect(id) {
      this.roleId = id;
      this.onSelectAll([]);
      this.getRolePermission();
    },
    // 获取角色权限
    getRolePermission: function () {
      var _getRolePermission = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.roleId > 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.$zybhttp.post('RolePermission/GetRolePerissionList', {
                  Field1: this.roleId + ''
                }).then(function (res) {
                  if (res.data.status == 0) {
                    res = res.data;
                    _this.loadingPermissions = false;
                    var permissionIds = res.data.list;
                    var rows = treeToList(_this.permissionTree);
                    rows.forEach(function (row) {
                      var checked = permissionIds.includes(row.id);

                      _this.$refs.multipleTable.toggleRowSelection(row, checked);
                    });
                    _this.checkedPermissions = _this.$refs.multipleTable.selection.map(function (s) {
                      return s.id;
                    });
                  } else {
                    _this.$notify.error(res.message);
                  }
                }).catch(function (err) {
                  return _this.$notify.error('网络异常！获取列表失败！');
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getRolePermission() {
        return _getRolePermission.apply(this, arguments);
      }

      return getRolePermission;
    }(),
    getRoles: function getRoles() {
      var _this2 = this;

      var userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
      this.$zybhttp.post('role/GetList', {
        Field3: userInfo.id + ''
      }).then(function (res) {
        if (res.data.status == 0) {
          res = res.data;
          var d = res.data.list;
          var newdata = d.sort(SortField('Id', 'desc'));
          _this2.roles = newdata;
        } else {
          _this2.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this2.$notify.error('网络异常！获取列表失败！');
      });
    },
    saveEdit: function saveEdit() {
      var _this3 = this;

      if (!(this.roleId > 0)) {
        this.$notify.warning('请选择角色！');
        return;
      }

      if (!(this.checkedPermissions.length > 0)) {
        this.$notify.warning('请选择菜单！');
        return;
      }

      var permissionIds = _toConsumableArray(this.checkedPermissions);

      var para = {
        permissionIds: permissionIds,
        roleId: this.roleId
      };
      this.$zybhttp.post('RolePermission/RolePermissionSave', para).then(function (res) {
        if (res.data.status == 0) {
          _this3.$notify.success(res.data.msg);
        } else {
          _this3.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this3.$notify.error('网络异常！获取列表失败！');
      });
    },
    handlePageChange: function handlePageChange(val) {
      this.$set(this.query, 'PageIndex', val);
      this.getData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    indexMethod: function indexMethod(index) {
      return index + 1;
    },
    onSelectAll: function onSelectAll(selection) {
      var _this4 = this;

      var selections = treeToList(selection);
      var rows = treeToList(this.viewTree);
      var checked = selections.length === rows.length;
      rows.forEach(function (row) {
        _this4.$refs.multipleTable.toggleRowSelection(row, checked);
      });
      this.sels = this.$refs.multipleTable.selection;
    },
    onSelect: function onSelect(selection, row) {
      var _this5 = this;

      var checked = selection.some(function (s) {
        return s.id === row.id;
      });

      if (row.children && row.children.length > 0) {
        var rows = treeToList(row.children);
        rows.forEach(function (r) {
          _this5.$refs.multipleTable.toggleRowSelection(r, checked);
        });
      }

      var parents = getTreeParentsWithSelf(this.permissionTree, row.id);
      parents.forEach(function (parent) {
        var checked = _this5.checkedPermissions.includes(parent.id);

        if (!checked) {
          _this5.$refs.multipleTable.toggleRowSelection(parent, true);
        }
      });
      this.checkedPermissions = this.$refs.multipleTable.selection.map(function (s) {
        return s.id;
      });
    },
    // 获取权限树
    getPermissions: function () {
      var _getPermissions = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this6 = this;

        var userInfo;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
                this.$zybhttp.post('Menu/GetMenuList', {
                  Field2: userInfo.id + ''
                }).then(function (res) {
                  if (res.data.status == 0) {
                    res = res.data;
                    var d = res.data.list;
                    var newdata = d.sort(SortField('sort', 'asc'));
                    newdata = newdata.map(function (x) {
                      x.enabledFt = x.enabled == '1';
                      return x;
                    }, []);
                    var keys = newdata.filter(function (l) {
                      return l.parentId === 9999;
                    }).map(function (l) {
                      return l.id + '';
                    });
                    _this6.expandRowKeys = keys; // var idd = this.MenuCarding(newdata);

                    var idd = listToTree(newdata);
                    _this6.permissionTree = idd;
                  } else {
                    _this6.$notify.error(res.message);
                  }
                }).catch(function (err) {
                  return _this6.$notify.error('网络异常！获取列表失败！');
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getPermissions() {
        return _getPermissions.apply(this, arguments);
      }

      return getPermissions;
    }()
  }
};